
class SideCartDealMessage extends HTMLElement {
  constructor() {
    super();
    let watch = this.dataset.dealIds;
    let currentCart = this.dataset.cartIds;
    let promos = this.dataset.promoIds;

    let _ids = watch.split(',');
    _ids.pop();

    let _pids = promos.split(',');
    _pids.pop();

    let _cart = currentCart.split(',');
    // _cart.pop();


    fetch(window.Shopify.routes.root + 'cart.js')
    .then(res => res.json())
    .then((res)=>{
      // console.log(res.items);
      let c = 0;

      let cartIDS = res.items.map((i)=>{
        return {id: i.id.toString(), q: i.quantity };
      })

      cartIDS.map((i)=>{
        // console.log(i);
        if (_ids.includes(i.id)){
          c+= i.q;
        }
      })

      this.setAttribute('data-count', c);
    })

  }

  static get observedAttributes() {
    return ["data-count"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    let dataCount = this.getAttribute("data-count");

    let promos = this.dataset.promoIds;
    let _pids = promos.split(',');
    _pids.pop();

    let currentCart = this.dataset.cartIds;
    let _cart = currentCart.split(',');

    if(name == 'data-count'){
      this.validateDeal(dataCount, _cart, _pids );
    }

  }

  validateDeal(count, cart, expected){
    let cap = Number(this.getAttribute('data-cap'));
    count = Number(count);

    if(count >= 1){
      this.classList.remove('visually-hidden');
      document.querySelector('#promo-freebies-wrapper-sidecart').classList.remove('visually-hidden');
    }

    if(count >= cap){
      this.setAttribute('data-qualifies', true);
    }

    if(count > cap){

      cart.map((c)=>{
        if (this.getAttribute('data-deal-ready') == "true" || expected.includes(c)){
            document.querySelector('#promo-freebies-wrapper-sidecart').classList.add('visually-hidden');
            this.querySelector(`#deal-status`).innerHTML = `Deal added`;
            document.querySelector('#deal-message-notification-sidecart').classList.add('visually-hidden');
        }
      })

    } else {
      this.setAttribute('data-deal-ready', false);
      // document.querySelector('#promo-freebies-wrapper-sidecart').classList.remove('visually-hidden');
      this.querySelector(`#deal-status`).innerHTML = `Looks like your missing out on a deal!`;
    }

  }

}

customElements.define("sidecart-deal-message", SideCartDealMessage);


class SideCartDealFreebie extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      let _id = this.id.replace('get-','');
      console.log(_id);

      let formData = {
        'items': [{
         'id': _id,
         'quantity': 1
         }],
        'sections': 'cart-drawer,cart-icon-bubble',
        'sections_url': window.location.pathname
       };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then((parsedState)=>{
        const cartDrawerHtml = parsedState.sections["cart-drawer"];
        const parser = new DOMParser();

        if (cartDrawerHtml) {
          const doc = parser.parseFromString(cartDrawerHtml, "text/html");
          const newElement = doc.querySelector("cart-notification-clone");
          const oldElement = document.querySelector("cart-notification-clone");

          if (oldElement && newElement) {
            oldElement.updateCartDrawerDOM(newElement, true);
          }
        }

        const cartIconBubbleHtml = parsedState.sections["cart-icon-bubble"];
        if (cartIconBubbleHtml) {
          const newBubbleDoc = parser.parseFromString(cartIconBubbleHtml, "text/html");
          const oldBubble = document.getElementById("cart-icon-bubble");
          const newBubble = newBubbleDoc.getElementById("cart-icon-bubble") || newBubbleDoc.querySelector(".shopify-section");
          if (oldBubble && newBubble) {
            oldBubble.innerHTML = newBubble.innerHTML;
          }
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    });
  }
}

customElements.define("side-cart-deal-freebie", SideCartDealFreebie);

class CartNotificationClone extends HTMLElement {
  constructor() {
    super();

    this.freeDeliveryCustomEl = document.querySelector("free-delivery");
    this.closeBtn = document.querySelector(
      ".cart-notification-clone-close-btn",
    );
    this.notificationCustomEl = document.querySelector("cart-notification");
    this.notificationClone = document.getElementById("cart-notification-clone");
    this.notificationCloneWrapper = document.getElementById(
      "cart-notification-clone-wrapper",
    );
    this.notificationCloneProductList = document.getElementById(
      "cart-notification-clone-product-list",
    );
    this.notificationCloneSubtotal = document.getElementById(
      "cart-notification-clone-price-subtotal",
    );
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notificationCloneWrapper.addEventListener("click", (e) => {
      this.handleBodyClick(e);
    });

    this.closeBtn.addEventListener("click", (e) => {
      this.hideClone();
    });

    this.notificationClone.addEventListener("click", (e) => {
      if (e.target.classList.contains("cart-notification-clone-minus-btn")) {
        const quantityInput = e.target.parentElement.querySelector("input");
        e.target.parentElement.setAttribute("inactive", "");

        if (+quantityInput.value < 2) {
          this.sendUpdateRequest(
            quantityInput,
            0,
            +quantityInput.getAttribute("data-line-index"),
            "minus",
          );
          return;
        }

        this.sendUpdateRequest(
          quantityInput,
          +quantityInput.value - 1,
          +quantityInput.getAttribute("data-line-index"),
          "minus",
        );
      }
      if (e.target.classList.contains("cart-notification-clone-plus-btn")) {
        const quantityInput = e.target.parentElement.querySelector("input");
        e.target.parentElement.setAttribute("inactive", "");
        this.sendUpdateRequest(
          quantityInput,
          +quantityInput.value + 1,
          +quantityInput.getAttribute("data-line-index"),
          "plus",
        );
      }
    });
  }

  sendUpdateRequest(quantityInput, newQuantity, lineIndex = 0, action) {
    const body = JSON.stringify({
      line: lineIndex,
      quantity: newQuantity,
      sections: ["cart-drawer", "cart-icon-bubble"],
      sections_url: window.location.pathname,
    });

    const updateConfig = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: body,
    };

    fetch(`${routes.cart_change_url}`, updateConfig)
      .then((response) => response.json())
      .then((parsedState) => {
        const cartDrawerHtml = parsedState.sections["cart-drawer"];
        const parser = new DOMParser();

        if (cartDrawerHtml) {
          const doc = parser.parseFromString(cartDrawerHtml, "text/html");
          const newElement = doc.querySelector("cart-notification-clone");
          const oldElement = document.querySelector("cart-notification-clone");

          if (oldElement && newElement) {
            oldElement.updateCartDrawerDOM(newElement, false);
          }
        }

        const cartIconBubbleHtml = parsedState.sections["cart-icon-bubble"];
        if (cartIconBubbleHtml) {
          const newBubbleDoc = parser.parseFromString(cartIconBubbleHtml, "text/html");
          const oldBubble = document.getElementById("cart-icon-bubble");
          const newBubble = newBubbleDoc.getElementById("cart-icon-bubble") || newBubbleDoc.querySelector(".shopify-section");
          if (oldBubble && newBubble) {
            oldBubble.innerHTML = newBubble.innerHTML;
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  updateCartDrawerDOM(newElement, openDrawer = false) {
    if (!newElement) return;

    // The desktop hover cart is a separate fragment from the side drawer.
    // Keep it in sync after every drawer mutation (add/change/remove).
    if (this.notificationCustomEl?.fetchCartContents) {
      this.notificationCustomEl.fetchCartContents(true);
    }

    // 1. Update the product list HTML smoothly
    const newList = newElement.querySelector('#cart-notification-clone-product-list');
    if (this.notificationCloneProductList && newList) {
      this.notificationCloneProductList.innerHTML = newList.innerHTML;
    }

    // 2. Update subtotal
    const newSubtotal = newElement.querySelector('#cart-notification-clone-price-subtotal');
    if (this.notificationCloneSubtotal && newSubtotal) {
      this.notificationCloneSubtotal.innerHTML = newSubtotal.innerHTML;
      this.notificationCloneSubtotal.setAttribute('data-subtotal', newSubtotal.getAttribute('data-subtotal'));
    }

    // 3. Update the free delivery progress bar
    if (this.freeDeliveryCustomEl && newSubtotal) {
      const subtotalVal = +newSubtotal.getAttribute('data-subtotal');
      this.freeDeliveryCustomEl.checkDelivery(subtotalVal);
    }

    // 4. Rebind event listeners to the new quantity inputs
    this.addQuantityInputEvents();

    // 5. Update recommendations only if the set of product IDs has changed
    this.showCartRecommendations();

    // 6. Optionally show/open the drawer if openDrawer is true
    if (openDrawer) {
      this.showClone();
    }
  }

  addQuantityInputEvents() {
    this.notificationCloneQuantities = document.querySelectorAll(
      ".cart-notification-clone-quantity",
    );

    this.notificationCloneQuantities.forEach((input) => {
      input.addEventListener("keyup", (e) => {
        const quantityInput = e.target;
        setTimeout(() => {
          if (e.target.value > 0) {
            e.target.parentElement.setAttribute("inactive", "");
            this.sendUpdateRequest(
              quantityInput,
              +quantityInput.value,
              +quantityInput.getAttribute("data-line-index"),
            );
          } else {
            e.target.parentElement.setAttribute("inactive", "");
            this.sendUpdateRequest(
              quantityInput,
              0,
              +quantityInput.getAttribute("data-line-index"),
              "minus",
            );
            return;
          }
        }, 1000);
      });
    });
  }

  showClone() {
    const quickAddModal = document.querySelector('.pdp__quickAds-modal-container');

    if (quickAddModal) {
      quickAddModal.classList.remove('open');
    }

    this.notificationCloneWrapper.classList.add("active");
    this.freeDeliveryCustomEl.checkDelivery(
      +this.notificationCloneSubtotal.getAttribute("data-subtotal"),
    );

    this.addQuantityInputEvents();
    this.showCartRecommendations();
  }

  hideClone() {
    this.notificationCloneWrapper.classList.remove("active");
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notificationClone &&
      !target.closest("#cart-notification-clone")
    ) {
      this.hideClone();
    }
  }

  async showCartRecommendations() {
    const currentVariantIds = Array.from(this.querySelectorAll('.cart-notification-clone-quantity'))
                                   .map(input => input.getAttribute('data-product-id'))
                                   .sort()
                                   .join(',');

    if (this.renderedVariantIds === currentVariantIds) {
      // Products in cart are the same, do not reload recommendations to avoid glitches!
      return;
    }

    this.renderedVariantIds = currentVariantIds;

    const response = await window.ecs.getCartRecommendations();
    const products = response?.recommendations;
    const cartRecommendationsContainer = this.querySelector("#cart-recommendations");
    const cartRecommendationsTitle = this.querySelector("#sidecart-products-recommends");

    if (!products || products.length < 1 || !cartRecommendationsContainer) {
      const existingSection = this.querySelector(".auc-Recommend");

      if (existingSection) {
        existingSection.style.display = 'none';
      }

      cartRecommendationsTitle?.classList.add("hidden");

      return;
    }

    cartRecommendationsTitle?.classList.remove("hidden");

    cartRecommendationsContainer.innerHTML = `
      <section class="auc-Recommend">
        <div class="auc-Recommend-container">
          <ol class="auc-Recommend-list"></ol>
        </div>
      </section>
    `;

    const listContainer = cartRecommendationsContainer.querySelector(".auc-Recommend-list");

    products.forEach((product) => {
      const productUrl = `${window.Shopify?.routes?.root || '/'}${'products/'}${product.handle}`;

      const currencySymbol = '£';

      const li = document.createElement("li");

      li.className = "auc-Recommend-item";
      li.innerHTML = `
        <a class="card-product card-carousel-js swiper-slide frequent-product-card" href="${productUrl}" data-type="trending">
          <img
            class="trending-product-img card-product__image"
            src="${product.image}"
            alt="${product.title}"
            style="width: 100px;"
          />
          <div class="frequent-product-details">
            <h4 class="frequent-product-name card-product__heading">${product.title}</h4>
            <span class="card-product__price frequent-product-price">${currencySymbol}${product.price}</span>
          </div>
        </a>
      `;

      listContainer.appendChild(li);
    });
  }
}

customElements.define("cart-notification-clone", CartNotificationClone);

class CartNotificationRecommendation extends HTMLElement {
  constructor() {
    super();

    this.cartRecQuantityWrapper = this.querySelector(
      ".cart-notification-rec-quantity",
    );
    this.cartRecQuantityInput =
      this.cartRecQuantityWrapper.querySelector("input");
    this.cartRecProductPrice = this.querySelector(
      ".cart-notification-rec-product-price",
    );

    this.cartRecQuantityWrapper.addEventListener("click", (e) => {
      if (e.target.classList.contains("cart-notification-rec-plus-btn")) {
        this.updateQuantity();
        return;
      }

      if (e.target.classList.contains("cart-notification-rec-minus-btn")) {
        this.updateQuantity("minus");
        return;
      }
    });
  }

  resetPrice() {}

  updatePrice(newQuantity) {
    const oldPrice = this.cartRecProductPrice.getAttribute(
      "data-product-price-total",
    );
    const newPrice =
      +this.cartRecProductPrice.getAttribute("data-product-price") *
      newQuantity;
    this.cartRecProductPrice.textContent =
      this.cartRecProductPrice.textContent.replace(
        oldPrice,
        newPrice.toFixed(2),
      );
    this.cartRecProductPrice.setAttribute(
      "data-product-price-total",
      newPrice.toFixed(2),
    );
  }

  updateQuantity(action = "plus") {
    if (action === "plus") {
      const newQuantity = +this.cartRecQuantityInput.value + 1;
      this.cartRecQuantityInput.value = newQuantity;
      this.cartRecQuantityInput.setAttribute("value", newQuantity);
      this.updatePrice(newQuantity);
      return;
    }

    if (action === "minus" && +this.cartRecQuantityInput.value > 1) {
      const newQuantity = +this.cartRecQuantityInput.value - 1;
      this.cartRecQuantityInput.value = newQuantity;
      this.cartRecQuantityInput.setAttribute("value", newQuantity);

      this.updatePrice(newQuantity);

      return;
    }
  }
}

customElements.define(
  "cart-notification-recommendation",
  CartNotificationRecommendation,
);
